var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.951172,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.307 12.4313C24.2334 12.1432 24.0924 11.8769 23.8955 11.6541C23.6987 11.4313 23.4517 11.2585 23.175 11.15C20.4969 10.1156 16.2344 10.125 16 10.125C15.7656 10.125 11.5031 10.1156 8.825 11.15C8.54825 11.2585 8.30128 11.4313 8.10445 11.6541C7.90762 11.8769 7.76658 12.1432 7.69297 12.4313C7.49063 13.2109 7.25 14.6359 7.25 17C7.25 19.3641 7.49063 20.7891 7.69297 21.5688C7.76647 21.8569 7.90746 22.1234 8.1043 22.3464C8.30113 22.5693 8.54816 22.7422 8.825 22.8508C11.3906 23.8406 15.4062 23.875 15.9484 23.875H16.0516C16.5938 23.875 20.6117 23.8406 23.175 22.8508C23.4518 22.7422 23.6989 22.5693 23.8957 22.3464C24.0925 22.1234 24.2335 21.8569 24.307 21.5688C24.5094 20.7875 24.75 19.3641 24.75 17C24.75 14.6359 24.5094 13.2109 24.307 12.4313ZM18.5461 17.5094L15.4211 19.6969C15.3276 19.7624 15.218 19.801 15.1041 19.8086C14.9902 19.8162 14.8764 19.7925 14.7751 19.74C14.6737 19.6875 14.5887 19.6083 14.5292 19.5109C14.4697 19.4135 14.438 19.3016 14.4375 19.1875V14.8125C14.4375 14.6982 14.4689 14.586 14.5283 14.4883C14.5876 14.3906 14.6726 14.311 14.774 14.2582C14.8755 14.2055 14.9894 14.1815 15.1035 14.189C15.2176 14.1965 15.3275 14.2352 15.4211 14.3008L18.5461 16.4883C18.6283 16.5459 18.6954 16.6225 18.7417 16.7116C18.7881 16.8007 18.8123 16.8996 18.8123 17C18.8122 17.1004 18.7881 17.1993 18.7417 17.2884C18.6954 17.3775 18.6283 17.4541 18.5461 17.5117V17.5094Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5b89614e8c58676b94a7e8367aee554d.svg";
export { ForwardRef as ReactComponent };